<app-breadcrumb [pathList]="pathList"></app-breadcrumb>
<div [ngBusy]="{busy: busy, message: 'Loading...', backdrop: false, delay: 0, minDuration: 600}"></div>


<div class="grid-container">

  <div class="grid-row">

    

    <div class="grid-item main-item">
      <a class="wrapping-link" ria-expanded="false" 
      [routerLink]="access_sections$?.RealMatches ? ['../real_match/list'] : null"
      [attr.aria-disabled]="!access_sections$?.RealMatches"
      [style.cursor]="!access_sections$?.RealMatches ? 'not-allowed !important' : 'pointer'"
      [ngClass]="{ 'disable-section': !access_sections$?.RealMatches}"
      ></a>
      <div class="grid-item-wrapper">
        <div class="grid-item-container">

          <div class="grid-content-centered">
            <i class="fas fa-futbol fa-fw"></i>
            Real Matches
          </div>

        </div>
      </div>
    </div>

    <div class="grid-item">
      <a class="wrapping-link" ria-expanded="false" 
          [routerLink]="access_sections$?.RealClubs ? ['../real_club/list'] : null"
          [attr.aria-disabled]="!access_sections$?.RealClubs"
          [style.cursor]="!access_sections$?.RealClubs ? 'not-allowed !important' : 'pointer'"
          [ngClass]="{ 'disable-section': !access_sections$?.RealClubs}"
          ></a>
      <div class="grid-item-wrapper">
        <div class="grid-item-container">

          <div class="grid-content-centered">
            <i class="fas fa-shield-alt fa-fw"></i>
            Real Clubs
          </div>

        </div>
      </div>
    </div>

    <div class="grid-item">
      <a class="wrapping-link" ria-expanded="false" 
          [routerLink]="access_sections$?.RealPlayers ? ['../real_player/list'] : null"
          [attr.aria-disabled]="!access_sections$?.RealPlayers"
          [style.cursor]="!access_sections$?.RealPlayers ? 'not-allowed !important' : 'pointer'"
          [ngClass]="{ 'disable-section': !access_sections$?.RealPlayers}"></a>
      <div class="grid-item-wrapper">
        <div class="grid-item-container">

          <div class="grid-content-centered">
            <i class="fas fa-user-shield fa-fw"></i>
            Real Players
          </div>

        </div>
      </div>
    </div>

    <div class="grid-item">
      <a class="wrapping-link" ria-expanded="false" 
          [routerLink]="access_sections$?.RealCompetitions ? ['../real_competition/list'] : null"
          [attr.aria-disabled]="!access_sections$?.RealCompetitions"
          [style.cursor]="!access_sections$?.RealCompetitions ? 'not-allowed !important' : 'pointer'"
          [ngClass]="{ 'disable-section': !access_sections$?.RealCompetitions}"></a>
      <div class="grid-item-wrapper">
        <div class="grid-item-container">

          <div class="grid-content-centered">
            <i class="fas fa-trophy fa-fw"></i>
            Real Competitions
          </div>

        </div>
      </div>
    </div>

    <div class="grid-item">
      <a class="wrapping-link" ria-expanded="false" 
          [routerLink]="access_sections$?.RealSeasons ? ['../real_competition/list'] : null"
          [attr.aria-disabled]="!access_sections$?.RealSeasons"
          [style.cursor]="!access_sections$?.RealSeasons ? 'not-allowed !important' : 'pointer'"
          [ngClass]="{ 'disable-section': !access_sections$?.RealSeasons}"></a>
      <div class="grid-item-wrapper">
        <div class="grid-item-container">

          <div class="grid-content-centered">
            <i class="fas fa-calendar fa-fw"></i>
            Real Seasons
          </div>

        </div>
      </div>
    </div>

    

    

  </div>
</div>